/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ScheduleCell_ValueFragment = { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', title: string } | null };

export type ScheduleCell_DisplayFragment = { __typename: 'Display', id: string, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', title: string } | null } | null };

export const ScheduleCell_ValueFragmentDoc = gql`
    fragment ScheduleCell_value on DisplaySchedule {
  schedule {
    title
  }
}
    `;
export const ScheduleCell_DisplayFragmentDoc = gql`
    fragment ScheduleCell_display on Display {
  id
  schedule {
    ...ScheduleCell_value
  }
}
    ${ScheduleCell_ValueFragmentDoc}`;